import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrayerWall from "./pages/PrayerWall";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PrayerWall />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#232323',
            border: '1px solid #262626',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}

export default App;
